<!-- @format -->

<div
  role="checkbox"
  [attr.id]="id"
  [attr.aria-checked]="ariaChecked"
  [attr.disabled]="disabled"
  [attr.aria-disabled]="disabled"
  (keydown.space)="$event.preventDefault()"
  (keyup.enter)="toggle()"
  (keyup.space)="toggle()"
  (click)="toggle()"
  tabindex="0"
  [attr.data-cy]="id">
  <label [for]="id" [class]="labelClasses" [class.disabled]="disabled">
    <span [class]="'icon-checkbox ' + controlClasses" [class.disabled]="disabled">
      @if (checked) {
        <sis-icon icon="check-small"></sis-icon>
      }
      @if (!checked && indeterminate) {
        <sis-icon icon="check-indeterminate-small"></sis-icon>
      }
    </span>
    <span class="labels">
      <span>
        @if (code) {
          <span>{{ code }}, </span>
        }
        {{ label | localizedString }}</span
      >
      @if (secondaryLabel) {
        <span class="secondary-label">
          {{ secondaryLabel | localizedString }}
        </span>
      }
    </span>
  </label>
</div>
